import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Row, Col } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faGripVertical } from '@fortawesome/pro-solid-svg-icons';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';
import badgeClass from '../shared/document_badge';
import { isMarketOverviewSlot } from './market_overview_slot';

export class DefaultPageRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    index: PropTypes.number.isRequired,
    page: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    onRemovePage: PropTypes.func.isRequired
  }


  render() {
    const { page } = this.props;
    if (!page) return null;

    const { connectDragPreview, connectDropTarget, connectDragSource, isDragging, onRemovePage, index } = this.props;
    const style = {
      opacity: isDragging ? 0 : 1,
    };

    return (
      connectDragPreview(
        connectDropTarget(
          <li className="list-group-item">
            <Row className="align-items-center w-100" style={style}>
              <Col xs={5}>
                {connectDragSource(
                  <div className="d-inline cursor-move">
                    <FontAwesomeIcon className="me-2" icon={faGripVertical} />
                  </div>
                )}
                <span>{page.name}</span>
              </Col>
              <Col xs={5}>
                {/* Colored by Blueprint's badge classes: its theme gives bg="info" white text and no background */}
                {isMarketOverviewSlot(page) && (
                  <Badge bg="" className="badge-primary badge-accent m-1" name="market-overview-slot-badge">
                    Fills with the property's market pages
                  </Badge>
                )}
                {page.user_label && (
                  <Badge className={`${badgeClass('user_label')} m-1`}>{page.user_label}</Badge>
                )}
                {page.size && (
                  <Badge bg="muted" className={`${badgeClass('size', page.size)} m-1`}>{page.size}</Badge>
                )}
              </Col>
              <Col className="text-end" xs={2}>
                <FontAwesomeIcon
                  className="text-danger clickable"
                  icon={faMinusCircle}
                  name="remove-page"
                  onClick={() => onRemovePage(index)}
                />
              </Col>
            </Row>
          </li>
        )
      )
    );
  }
}

export default reorderableListItem(DefaultPageRow, 'defaultPageRow', {
  beginDrag(props) {
    return {
      id: props.page.id,
      index: props.index
    };
  }
});
